import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { isUiMobile } from '@/redux/modules/browser';
import { isWhiteLabel } from '@/redux/modules/whiteLabel';
import { openFeedbackModal } from '@/redux/modules/modal';
import { useLocation } from 'react-router-dom';

const FeedbackLink = () => {
    const dispatch = useDispatch();
    const mobile = useSelector(isUiMobile);
    const whiteLabel = useSelector(isWhiteLabel);
    const { pathname } = useLocation();
    const isCheckoutPage = pathname.includes('checkout');

    const formLinkClick = () => {
        dispatch(openFeedbackModal());
    };

    const showWidget = !mobile && !whiteLabel && !isCheckoutPage;

    return showWidget ? (
        <div className="form-link-container" id="desk-form-link-container">
            <a className="form-link" href="#" onClick={formLinkClick}>
                <FormattedMessage id="feedback.feedback" />
            </a>
        </div>
    ) : null;
};

export default FeedbackLink;
